import PropTypes from 'prop-types';

function getUrlWithParams(src, params) {
  const href = src.split('?')[0];
  const combinedParams = {
    ...Object.fromEntries(new URLSearchParams(src.split('?')[1] || '')),
    ...params,
  };

  // Remove anything that is null / undefined / empty string
  Object.keys(combinedParams).forEach((key) => {
    if (combinedParams[key] === null || combinedParams[key] === undefined || combinedParams[key] === '') {
      delete combinedParams[key];
    }
  });

  // Using encodeURIComponent here instead of URLSearchParams as URLSearchParams encodes things like spaces differently
  // Use replace rather than replaceAll because many of our users have IE
  const encodedParamString = Object.keys(combinedParams)
    .map((k) => `${k}=${combinedParams[k]}`)
    .join('&')
    .replace(/%2F/g, '/');

  return `${href}?${encodedParamString}`;
}

const RedEye = ({ src = 'https://reporting.breakfreeholidays.co.uk/cgi-bin/rr/blank.gif', params = {} }) => (
  <img
    src={getUrlWithParams(src, params)}
    width="1"
    height="1"
    alt=""
    style={{
      display: 'block',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      pointerEvents: 'none',
      opacity: 0,
    }}
  />
);

RedEye.propTypes = {
  src: PropTypes.string,
  params: PropTypes.object,
};

export default RedEye;
